
import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, useRef } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const mountedRef = useRef(true);
  
  useEffect(() => {
    mountedRef.current = true;
    
    if (!window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE = navigate;
      navigateResolver(window.REACT_APP_NAVIGATE);
    }
    
    // Retour automatique en haut de page à chaque changement de route
    if (mountedRef.current) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    return () => {
      mountedRef.current = false;
    };
  }, [navigate, element]);
  
  return element;
}
